import { authProvider } from "../context/authProvider";
import { useLocation } from "react-router-dom";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import BitacoraFaltantesTable from "../components/Tables/Reportes/BitacoraFaltantesTable";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import "../theme/ReporteCierreDia.css";

/** Reporte faltantes */
const BitacoraFaltantes = () => {
  const { state } = useLocation();

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption="Volver a reportes" />
                </div>
              </div>
              <BitacoraFaltantesTable />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};

export default BitacoraFaltantes;
